import { DUPLEXER_EVENTS } from '../createDuplexerChannel';
export const mapper = (message, privateAdapter) => {
  switch (message.type) {
    case DUPLEXER_EVENTS.COPY_FILE:
      return {
        ...message,
        info: {
          ...message.info,
          data: privateAdapter.toItem(message.info.data)
        }
      };
    case DUPLEXER_EVENTS.COPY_FOLDER:
      return {
        ...message,
        info: {
          ...message.info,
          data: privateAdapter.toFolder(message.info.data)
        }
      };
    default:
      return message;
  }
};